import {keywordIncludeContentsEnabled} from '@netx/core-search-next/enablers';
import {SearchTypeKeyword, KeywordType} from './constants';
import {keywordRuleDefaults} from './defaults';
import {KeywordRule} from './types';

type KeywordRuleParams<T extends KeywordType = KeywordType> = {
	includeContents?: boolean;
	keyword: string;
	type?: T;
};

export const createKeywordRule = <
	T extends KeywordType = typeof keywordRuleDefaults.elementSubType1,
>({
	includeContents,
	keyword,
	type,
}: KeywordRuleParams<T>): KeywordRule => ({
	...keywordRuleDefaults,
	elementType: SearchTypeKeyword,
	elementSubType1: type != null ? type : keywordRuleDefaults.elementSubType1,
	elementValue1: keyword,
	elementValue2:
		includeContents ||
		(includeContents !== false && keywordIncludeContentsEnabled())
			? 'true'
			: '',
});

export default createKeywordRule;
